var map = {
	"./33687563.png": 8148,
	"./HBLAB_JSC.png": 7939,
	"./New Text Document.txt": 6724,
	"./address_image.svg": 256,
	"./amrita_logo.png": 9876,
	"./base_systemes_logo.png": 9172,
	"./coursera_logo.png": 4664,
	"./doist_logo.png": 1516,
	"./duke-logo.jpg": 7793,
	"./eleks_logo.png": 5159,
	"./gcp_logo.png": 4585,
	"./ggsipu_logo.png": 1007,
	"./google_logo.png": 8720,
	"./infosys-logo.png": 9006,
	"./logo_optimized.png": 4942,
	"./mail.gif": 526,
	"./mail.png": 3655,
	"./maryland_logo.svg": 6393,
	"./meta_logo.png": 484,
	"./osaka_logo.png": 1374,
	"./payever.jpg": 3159,
	"./portfolioProfileImage.jfif": 6242,
	"./portfolioProfileImage.png": 4836,
	"./practice.png": 2732,
	"./sakura_logo.png": 2517,
	"./sutd_logo.png": 2728,
	"./taro112.png": 8597,
	"./taro112_contact.jpg": 8764,
	"./taro_contact.png": 1229,
	"./trust.png": 9600,
	"./waving-hand.png": 8697
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;